// @flow
import React from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { numberWithCommas } from 'lib/common';
import 'moment/locale/ko';
import './OfferTemplate.scss';

type Props = {
  cart: any,
};

const OfferTemplate = (props: Props) => (
  <div className="OfferTemplate">
    <Helmet>
      <title>{`캐시바이-견적서-${moment().format('YYYY-MM-DD-HH:mm:ss')}`}</title>
    </Helmet>
    <div className="main">
      <div className="offer order-offer">
        <div className="offer-process">
          <div className="cart-items">
            <div data-top>
              <h2 data-title>견적서</h2>
              <img src="https://images.cacheby.com/datasee_stamp.png" alt="stamp" className="stamp" />
              <dl data-top-info>
                <dt data-label>날짜</dt>
                <dd data-value>{moment().format('YYYY-MM-DD')}</dd>
                <dt data-label>유효일</dt>
                <dd data-value>{moment().format('YYYY-MM-DD')}</dd>
              </dl>
            </div>
            <div data-seller>
              <h2 data-title>판매자</h2>
              <table data-table>
                <tbody>
                  <tr>
                    <th data-label scope="row">
                      상호(법인명/서비스명)
                    </th>
                    <td data-value>(주)데이터씨 / 캐시바이</td>
                    <th data-label scope="row">
                      대표
                    </th>
                    <td data-value>최영진</td>
                  </tr>
                  <tr>
                    <th data-label scope="row">
                      연락처(휴대폰)
                    </th>
                    <td data-value>02-585-1342</td>
                    <th data-label scope="row">
                      이메일
                    </th>
                    <td data-value>info@cacheby.com</td>
                  </tr>
                  <tr>
                    <th data-label scope="row">
                      주소
                    </th>
                    <td data-value>서울시 서초구 동광로1길 52, 1층</td>
                    <th data-label scope="row">
                      사업자번호
                    </th>
                    <td data-value>464-81-00805</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <table className="table">
              <thead>
                <tr>
                  <th>번호</th>
                  <th>카탈로그 번호</th>
                  <th>물품명</th>
                  <th>단위</th>
                  <th>수량</th>
                  <th>단가</th>
                  <th>가격</th>
                  <th>세액</th>
                </tr>
              </thead>

              <tbody>
                {props.cart.items.map((item, index) => (
                  <tr key={item.id} className="cart-item" data-item={item.id}>
                    <td className="cart-item-number">
                      <span className="cart-item-number-label hidden">번호</span>
                      <span className="cart-item-number-value">{index + 1}</span>
                    </td>
                    <td className="cart-item-number">
                      <span className="cart-item-number-label hidden">카탈로그 번호</span>
                      <span className="cart-item-number-value">{item.product_price.part_number}</span>
                    </td>
                    <td className="cart-item-name">
                      <div className="cart-item-summary">
                        <span className="cart-item-name">{item.product_price.description}</span>
                      </div>
                    </td>

                    <td className="cart-item-number">
                      <span className="cart-item-number-label hidden">단위</span>
                      <span className="cart-item-number-value">{item.product_price.unit}</span>
                    </td>
                    <td className="cart-item-quantity">
                      <span className="cart-item-quantity-label hidden">수량</span>
                      <span className="cart-item-quantity-value">{item.quantity}</span>
                    </td>

                    <td className="cart-item-price">
                      <span className="cart-item-sale-price">
                        {numberWithCommas(item.price.sale.raw)}원
                      </span>
                      {item.price.sale.raw !==
                        item.price.original.raw && (
                        <span className="cart-item-compare-price">
                          {numberWithCommas(item.price.original.raw)}원
                        </span>
                      )}
                    </td>
                    <td className="cart-item-price">
                      <span className="cart-item-sale-price">{numberWithCommas(item.total.price.sale.raw)}원</span>
                      {item.total.price.sale.raw !== item.total.price.original.raw && (
                        <span className="cart-item-compare-price">
                          {numberWithCommas(item.total.price.original.raw)}원
                        </span>
                      )}
                      {item.total.price.sale.raw !== item.total.price.original.raw && (
                        <span className="cart-item-discounted">
                          (-{numberWithCommas(item.total.discounted.raw)}원)
                        </span>
                      )}
                    </td>
                    <td className="cart-item-price">
                      <span className="cart-item-sale-price">{numberWithCommas(item.total.taxed.raw)}원</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div data-bottom>
              <div data-notes>
                <div data-title>추가설명</div>
                <span data-desc>* 수입 및 주문 후 생산방식 제품의 경우 반품 불가합니다.</span>
                <br />
                <span data-desc>
                  * 상기금액은 견적일에 따라 주문 금액의 차이가 발생할 수 있습니다.
                </span>
              </div>
              <dl data-toatal-area>
                <dt data-label="sumPrice">총합</dt>
                <dd className="sumPrice" data-value="sumPrice">
                  <span className="cart-item-sale-price">
                    {numberWithCommas(props.cart.total.price.sale.raw)}원
                  </span>
                  {props.cart.total.price.sale.raw !==
                    props.cart.total.price.original.raw && (
                      <span className="cart-items-compare-price">
                        {numberWithCommas(props.cart.total.price.original.raw)}원
                      </span>
                  )}
                  {props.cart.total.price.sale.raw !==
                    props.cart.total.price.original.raw && (
                    <span className="cart-items-discounted">
                      (-{numberWithCommas(props.cart.total.discounted.raw)}원)
                    </span>
                  )}
                </dd>
                <dt data-label="sumVat">배송비</dt>
                <dd data-value="sumVat">{numberWithCommas(props.cart.total.shipping.fee.sale.raw)}원</dd>
                <dt data-label="sumTotal">부가세</dt>
                <dd data-value="sumTotal">{numberWithCommas(props.cart.total.taxed.raw)}원</dd>
                <br />
                <dt data-label="sumTotal">총계</dt>
                <dd data-value="sumTotal">{numberWithCommas(props.cart.total.amount.raw)}원</dd>
              </dl>
            </div>
            <div className="logo-wrapper">
              <img
                src={'https://images.cacheby.com/logo.svg'}
                alt="logo"
                className="logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OfferTemplate;



// WEBPACK FOOTER //
// ./src/components/offer/OfferTemplate/OfferTemplate.js